export default __webpack_public_path__ + "static/media/tiktok.ee0971d8.svg";